import React, { useMemo, useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import api from "../../api";

const ApiTable = () => {
  const [apiRes, setApiRes] = useState({});

  const allowedEquipments = [
    "NONGL_SS_DG_ENERGY_METER",
    "NONGL_SS_ENERGY_METER_TRANSFORMER",
    "NONGL_SS_ENERGY_METER_LIFT",
    "NONGL_SS_ENERGY_METER_LIGHT_AND_POWER",
    "NONGL_SS_ENERGY_METER_SDB_EMERGENCY",
    "NONGL_SS_ENERGY_METER_CAR_CHARGER",
    "NONGL_SS_ENERGY_METER_UPS",
    "NONGL_SS_ENERGY_METER_LT_PANEL",
    "NONGL_SS_ENERGY_METER_VRB",
    "NONGL_SS_EMS"
  ];

  // Alias map for equipment groups (friendly names)
  const aliasMap = {
    NONGL_SS_DG_ENERGY_METER: "DG Meter",
    NONGL_SS_ENERGY_METER_TRANSFORMER: "Transformer Meter",
    NONGL_SS_ENERGY_METER_LIFT: "Lift Meter",
    NONGL_SS_ENERGY_METER_LIGHT_AND_POWER: "L&P Meter",
    NONGL_SS_ENERGY_METER_SDB_EMERGENCY: "SDB Emergency Meter",
    NONGL_SS_ENERGY_METER_CAR_CHARGER: "Car Charger",
    NONGL_SS_ENERGY_METER_UPS: "UPS Meter",
    NONGL_SS_ENERGY_METER_LT_PANEL: "LT Panel",
    NONGL_SS_ENERGY_METER_VRB: "VRV Meter",
    NONGL_SS_EMS: "Firefighting EMS"
  };

  const col = [
    { parameter1: "Alias", displayName: "Equipment" },
    //{ parameter1: "Equipment" , displayName: "Equipment Tag"},
    {
      displayName: "Power Consumption",
      parameterMap: {
        NONGL_SS_DG_ENERGY_METER: "DG_EM_Metering_WH",
        NONGL_SS_ENERGY_METER_TRANSFORMER: "EM_TR_WH",
        NONGL_SS_ENERGY_METER_LIFT: "EM_LIFT_RM_WH",
        NONGL_SS_ENERGY_METER_LIGHT_AND_POWER:
          "EM_Light_Power_Schnider_Meter_Kwh",
        NONGL_SS_ENERGY_METER_SDB_EMERGENCY:
          "EM_SDB_Emergency_Schnider_kwh",
        NONGL_SS_ENERGY_METER_CAR_CHARGER: "EM_CAR_Charger_WH",
        NONGL_SS_ENERGY_METER_UPS: ["EM_UPS_WH", "EM_UPS_Schnider_Meter_1_KWH"],
        NONGL_SS_ENERGY_METER_LT_PANEL: "EM_LT_PANEL_WH",
        NONGL_SS_ENERGY_METER_VRB: "EMS_VRB_KWH",
        NONGL_SS_EMS: "EM_Firefighting_Kwh"
      },
    },
    {
      displayName: "Load-KW",
      parameterMap: {
        NONGL_SS_DG_ENERGY_METER: ["DG_EM_Load", "DG_EM_WATT"],
        NONGL_SS_ENERGY_METER_CAR_CHARGER: "EM_CAR_Charger_WATT",
        NONGL_SS_ENERGY_METER_LIFT: "EM_Lift_WATT",
        NONGL_SS_ENERGY_METER_LIGHT_AND_POWER: "EM_Light_Power_Schnider_kw",
        NONGL_SS_ENERGY_METER_SDB_EMERGENCY: "EM_SDB_Emergency_Schnider_kw",
        NONGL_SS_ENERGY_METER_UPS: ["EM_UPS_Watt", "EM_UPS_Schnider_kw"],
        NONGL_SS_ENERGY_METER_LT_PANEL: "EM_LT_WATT",
        NONGL_SS_ENERGY_METER_TRANSFORMER: "EM_TR_Watt",
        NONGL_SS_ENERGY_METER_VRB: "EMS_VRB_KW",
        NONGL_SS_EMS: "EM_Firefighting_kw"
      },
    },
    {
      displayName: "PowerFactor",
      parameterMap: {
        NONGL_SS_DG_ENERGY_METER: ["DG_EM_Power_Factor", "DG_EM_AV_PF"],
        NONGL_SS_ENERGY_METER_LIGHT_AND_POWER: "EM_Light_Power_Schnider_PF",
        NONGL_SS_ENERGY_METER_SDB_EMERGENCY: "EM_SDB_Emergency_Schnider_PF",
        NONGL_SS_ENERGY_METER_CAR_CHARGER: "EM_CAR_Charger_AV_PF",
        NONGL_SS_ENERGY_METER_UPS: ["EM_UPS_AV_PF", "EM_UPS_Schnider_PF"],
        NONGL_SS_ENERGY_METER_LT_PANEL: "EM_LT_AV_PF",
        NONGL_SS_ENERGY_METER_LIFT: "EM_Lift_AV_PF",
        NONGL_SS_ENERGY_METER_TRANSFORMER: "EM_TR_AV_PF",
        NONGL_SS_ENERGY_METER_VRB: "EMS_VRB_PF",
        NONGL_SS_EMS: "EM_Firefighting_PF"
      },
    },
    {
      displayName: "Frequency",
      parameterMap: {
        NONGL_SS_DG_ENERGY_METER: ["DG_EM_Frequency", "DG_EM_Metering_Freq"],
        NONGL_SS_ENERGY_METER_TRANSFORMER: "EM_TR_Freq",
        NONGL_SS_ENERGY_METER_LIFT: "EM_LIFT_RM_Freq",
        NONGL_SS_ENERGY_METER_LIGHT_AND_POWER:
          "EM_Light_Power_Schnider_meter_Freq",
        NONGL_SS_ENERGY_METER_SDB_EMERGENCY:
          "EM_SDB_Emergency_Schnider_meter_FREQ",
        NONGL_SS_ENERGY_METER_CAR_CHARGER: "EM_CAR_Charger_Freq",
        NONGL_SS_ENERGY_METER_UPS: "EM_UPS_Freq",
        NONGL_SS_ENERGY_METER_LT_PANEL: "EM_LT_PANEL_Freq",
        NONGL_SS_ENERGY_METER_VRB: "EMS_VRB_FREQ",
        NONGL_SS_EMS: "EM_Firefighting_Freq"
      },
    },


    {
      displayName: "Voltage-R",
      parameterMap: {
        NONGL_SS_ENERGY_METER_LIGHT_AND_POWER:
          "EM_Light_Power_Schnider_meter_phase_volt_R_B",
        NONGL_SS_ENERGY_METER_SDB_EMERGENCY:
          "EM_SDB_Emergency_Schnider_meteR_phase_volt_R_Y",
        NONGL_SS_ENERGY_METER_CAR_CHARGER: "EM_CAR_Charger_V_R_PHASE",
        NONGL_SS_ENERGY_METER_UPS: ["EM_UPS_V_R_PHASE", "EM_UPS_Schnider_meter_phase_volt_R_Y", "EM_UPS_Schnider_meter_phase_curent_R"],
        NONGL_SS_ENERGY_METER_VRB: "EMS_VRB_Volt_Phase_R",
        NONGL_SS_DG_ENERGY_METER: "DG_EM_Metering_R_Phase",
        NONGL_SS_ENERGY_METER_LT_PANEL: "EM_LT_PANEL_R_PHASE",
        NONGL_SS_ENERGY_METER_LIFT: "EM_LIFT_RM_R_Phase",
        NONGL_SS_ENERGY_METER_TRANSFORMER: "EM_TR_R_Phase",
        NONGL_SS_EMS: "EM_Firefighting_phase_volt_RB"

      },
    },
    {
      displayName: "Voltage-Y",
      parameterMap: {
        NONGL_SS_ENERGY_METER_LIGHT_AND_POWER:
          "EM_Light_Power_Schnider_meter_phase_volt_R_Y",
        NONGL_SS_ENERGY_METER_SDB_EMERGENCY:
          "EM_SDB_Emergency_Schnider_meter_phase_volt_Y_B",
        NONGL_SS_ENERGY_METER_CAR_CHARGER: "EM_CAR_Charger_V_Y_PHASE",
        NONGL_SS_ENERGY_METER_UPS: ["EM_UPS_V_Y_PHASE", "EM_UPS_Schnider_meter_phase_volt_Y_B", "EM_UPS_Schnider_meter_phase_curent_Y"],
        NONGL_SS_ENERGY_METER_VRB: "EMS_VRB_Volt_Phase_Y",
        NONGL_SS_DG_ENERGY_METER: "DG_EM_Metering_Y_Phase",
        NONGL_SS_ENERGY_METER_LT_PANEL: "EM_LT_PANEL_Y_PHASE",
        NONGL_SS_ENERGY_METER_LIFT: "EM_LIFT_RM_Y_Phase",
        NONGL_SS_ENERGY_METER_TRANSFORMER: "EM_TR_Y_Phase",
        NONGL_SS_EMS: "EM_Firefighting_phase_volt_RY"
      },
    },
    {
      displayName: "Voltage-B",
      parameterMap: {
        NONGL_SS_ENERGY_METER_LIGHT_AND_POWER:
          "EM_Light_Power_Schnider_meter_phase_volt_Y_B",
        NONGL_SS_ENERGY_METER_CAR_CHARGER: "EM_CAR_Charger_V_B_PHASE",
        NONGL_SS_ENERGY_METER_UPS: ["EM_UPS_V_B_PHASE", "EM_UPS_Schnider_meter_phase_volt_R_B", "EM_UPS_Schnider_meter_phase_curent_B"],
        NONGL_SS_DG_ENERGY_METER: "DG_EM_Metering_B_Phase",
        NONGL_SS_ENERGY_METER_LT_PANEL: "EM_LT_PANEL_B_PHASE",
        NONGL_SS_ENERGY_METER_LIFT: "EM_LIFT_RM_B_Phase",
        NONGL_SS_ENERGY_METER_TRANSFORMER: "EM_TR_B_Phase",
        NONGL_SS_ENERGY_METER_SDB_EMERGENCY:
          "EM_SDB_Emergency_Schnider_meter_phase_volt_R_B",
        NONGL_SS_ENERGY_METER_VRB: "EMS_VRB_Volt_Phase_B",
        NONGL_SS_EMS: "EM_Firefighting_phase_volt_YB"
      },
    },
    {
      displayName: "Current-R",
      parameterMap: {
        NONGL_SS_DG_ENERGY_METER: "DG_EM_Current_R_Phase",
        NONGL_SS_ENERGY_METER_TRANSFORMER: "EM_TR_Current_R_Phase",
        NONGL_SS_ENERGY_METER_LIFT: "EM_Lift_Current_R_Phase",
        NONGL_SS_ENERGY_METER_LIGHT_AND_POWER:
          "EM_Light_Power_Schnider_meter_phase_curent_R",
        NONGL_SS_ENERGY_METER_SDB_EMERGENCY:
          "EM_SDB_Emergency_Schnider_meter_phase_curent_R",
        NONGL_SS_ENERGY_METER_CAR_CHARGER: "EM_CAR_Charger_Current_R_Phase",
        NONGL_SS_ENERGY_METER_UPS: "EM_UPS_Current_R_Phase",
        NONGL_SS_ENERGY_METER_LT_PANEL: "EM_LT_Current_R_Phase",
        NONGL_SS_ENERGY_METER_VRB: "EMS_VRB_Current_R_Phase",
        NONGL_SS_EMS: "EM_Firefighting_phase_curent_R"
      },
    },
    {
      displayName: "Current-Y",

      parameterMap: {
        NONGL_SS_DG_ENERGY_METER: "DG_EM_Current_Y_Phase",
        NONGL_SS_ENERGY_METER_TRANSFORMER: "EM_TR_Current_Y_Phase",
        NONGL_SS_ENERGY_METER_LIFT: "EM_Lift_Current_Y_Phase",
        NONGL_SS_ENERGY_METER_LIGHT_AND_POWER:
          "EM_Light_Power_Schnider_meter_phase_curent_Y",
        NONGL_SS_ENERGY_METER_SDB_EMERGENCY:
          "EM_SDB_Emergency_Schnider_meter_phase_curent_Y",
        NONGL_SS_ENERGY_METER_CAR_CHARGER: "EM_CAR_Charger_Current_Y_Phase",
        NONGL_SS_ENERGY_METER_UPS: ["EM_UPS_Current_Y_PHASE", "EM_UPS_Current_Y_Phase"],
        NONGL_SS_ENERGY_METER_LT_PANEL: "EM_LT_Current_Y_Phase",
        NONGL_SS_ENERGY_METER_VRB: "EMS_VRB_Current_Y_Phase",
        NONGL_SS_EMS: "EM_Firefighting_phase_curent_Y"
      },
    },

    {
      displayName: "Current-B",
      parameterMap: {
        NONGL_SS_DG_ENERGY_METER: "DG_EM_Current_B_Phase",
        NONGL_SS_ENERGY_METER_TRANSFORMER: "EM_TR_Current_B_Phase",
        NONGL_SS_ENERGY_METER_LIFT: "EM_Lift_Current_B_Phase",
        NONGL_SS_ENERGY_METER_LIGHT_AND_POWER:
          "EM_Light_Power_Schnider_meter_phase_curent_B",
        NONGL_SS_ENERGY_METER_SDB_EMERGENCY:
          "EM_SDB_Emergency_Schnider_meter_phase_curent_B",
        NONGL_SS_ENERGY_METER_CAR_CHARGER: "EM_CAR_Charger_Current_B_Phase",
        NONGL_SS_ENERGY_METER_UPS: "EM_UPS_Current_B_Phase",
        NONGL_SS_ENERGY_METER_LT_PANEL: "EM_LT_Current_B_Phase",
        NONGL_SS_ENERGY_METER_VRB: "EMS_VRB_Current_B_Phase",
        NONGL_SS_EMS: "EM_Firefighting_phase_curent_B"
      },
    },
    {
      displayName: "Total Current",
      parameterMap: {
        NONGL_SS_DG_ENERGY_METER: "DG_EM_Total_Current",
        NONGL_SS_ENERGY_METER_TRANSFORMER: "EM_TR_Total_Current",
        NONGL_SS_ENERGY_METER_LIFT: "EM_Lift_Total_Current",
        // NONGL_SS_ENERGY_METER_LIGHT_AND_POWER:
        //   "EM_Light_Power_Schnider_meter_phase_curent_B",
        // NONGL_SS_ENERGY_METER_SDB_EMERGENCY:
        //   "EM_SDB_Emergency_Schnider_meter_phase_curent_B",
        NONGL_SS_ENERGY_METER_CAR_CHARGER: "EM_CAR_Charger_Total_Current",
        NONGL_SS_ENERGY_METER_UPS: "EM_UPS_Current_Total",
        NONGL_SS_ENERGY_METER_LT_PANEL: "EM_LT_Total_Current",
        // NONGL_SS_ENERGY_METER_VRB: "EMS_VRB_Current_B_Phase",
      },
    },


  ];

  useEffect(() => {
    const fetchData = () => {
      api.floor
        .cpmGetDevData()
        .then((response) => setApiRes(response))
        .catch((err) => console.error("API Fetch Error:", err));
    };
    fetchData();
    const timer = setInterval(fetchData, 5000);
    return () => clearInterval(timer);
  }, []);

  // Helper function to format numeric values
  const formatValue = (value) => {
    if (value === undefined || value === null || value === "") return "NA";

    // Convert to string to check
    const strValue = String(value).trim();
    if (strValue === "" || strValue === "-") return "NA";

    // Try to parse as number
    const numValue = parseFloat(strValue);
    if (isNaN(numValue)) return strValue; // Return as-is if not a number

    return numValue.toFixed(2);
  };

  const flattenData = (data) => {
    const rows = [];
    const equipmentCount = {}; // Count total equipment per type
    const equipmentIndex = {}; // Track current index for numbering

    // First pass: count equipment by type
    Object.entries(data || {}).forEach(([groupKey, deviceGroup]) => {
      if (!allowedEquipments.includes(groupKey)) return;
      Object.values(deviceGroup || {}).forEach((device) => {
        equipmentCount[groupKey] = (equipmentCount[groupKey] || 0) + 1;
      });
    });

    // Second pass: create rows with numbering only if count > 1
    Object.entries(data || {}).forEach(([groupKey, deviceGroup]) => {
      if (!allowedEquipments.includes(groupKey)) return;
      Object.values(deviceGroup || {}).forEach((device) => {
        let alias = aliasMap[groupKey] || "-";

        // Add numbering only if there are multiple equipment of this type
        if (equipmentCount[groupKey] > 1) {
          equipmentIndex[groupKey] = (equipmentIndex[groupKey] || 0) + 1;
          alias = `${alias} ${equipmentIndex[groupKey]}`;
        }

        const row = {
          Alias: alias,
          Equipment: device?.name || "-",
          EquipmentGroup: groupKey,
        };
        const attributes = device?.Eqp_Attributes || {};
        Object.entries(attributes).forEach(([attrName, attrValue]) => {
          row[attrName] = attrValue?.presentValue; // ⬅️ Store RAW value, don't format yet
        });
        rows.push(row);
      });
    });
    // Sort rows alphabetically by Equipment
    rows.sort((a, b) => a.Equipment.localeCompare(b.Equipment));

    const finalRows = rows.map((device) => {
      const filtered = {};
      col.forEach((c) => {
        let value = "-";
        if (c.parameterMap) {
          const paramKey = c.parameterMap[device.EquipmentGroup];
          console.log(`Processing column "${c.displayName}" for device "${device.Equipment}":`, { paramKey, device });
          // Handle array of parameters (show first available)
          if (Array.isArray(paramKey)) {
            for (const key of paramKey) {
              const val = device[key];
              // console.log(`Checking parameter "${key}" for device "${device.Equipment}":`, val);
              // Check for valid raw values
              if (val !== undefined && val !== null && val !== "" && val !== "-") {
                value = val;
                break; // Use first available value and stop
              }
            }
          } else if (paramKey && device[paramKey] !== undefined) {
            value = device[paramKey];
          }
        } else if (c.parameter1) {
          value = device[c.parameter1] ?? "-";
        }
        // console.log("Flattened value Before Sorting:", value);
        // Format the value for display ONLY at the end
        value = formatValue(value);

        const columnName = c.displayName || c.parameter1;
        filtered[columnName] = value;
      });
      return filtered;
    });

    const columnDefs = col.map((c) => {
      const isAlias = c.parameter1 === "Alias";
      const isEquipment = c.parameter1 === "Equipment";
      return {
        headerName: c.displayName || c.parameter1,
        field: c.displayName || c.parameter1,
        sortable: true,
        resizable: true,
        filter: true,
        width: 180,
        pinned: isAlias || isEquipment ? "left" : undefined,
        cellStyle: isAlias || isEquipment ? { textAlign: "left", paddingLeft: "10px" } : { textAlign: "center" },
        cellClass: isAlias ? "alias-cell" : isEquipment ? "equipment-cell" : undefined,
        headerClass: isAlias ? "center-header alias-header" : isEquipment ? "center-header equipment-header" : "center-header",
      };
    });

    return { rows: finalRows, columnDefs };
  };

  const { rows, columnDefs } = useMemo(() => flattenData(apiRes), [apiRes]);

  return (
    <>
      <style>
        {`
          .center-header .ag-header-cell-label {
            justify-content: center;
          }

          /* Full-height vertical divider between Alias (Equipment Tag) and Equipment */
          .ag-theme-alpine .alias-cell {
            border-right: 1px solid #d8d8d8;
          }
          .ag-theme-alpine .equipment-cell {
            border-left: 1px solid #d8d8d8;
          }

          /* Header styling to align with cells */
          .ag-theme-alpine .alias-header .ag-header-cell-label,
          .ag-theme-alpine .equipment-header .ag-header-cell-label {
            justify-content: center;
          }
          .ag-theme-alpine .alias-header .ag-header-cell,
          .ag-theme-alpine .alias-header {
            border-right: 1px solid #d8d8d8;
          }
          .ag-theme-alpine .equipment-header .ag-header-cell,
          .ag-theme-alpine .equipment-header {
            border-left: 1px solid #d8d8d8;
          }
        `}
      </style>
      <div
        className="ag-theme-alpine"
        style={{ height: "80vh", width: "100%", marginTop: "20px" }}
      >
        <AgGridReact
          rowData={rows}
          columnDefs={columnDefs}
          defaultColDef={{
            flex: 1,
            minWidth: 150,
            resizable: true,
            sortable: true,
            filter: true,
          }}
        />
      </div>
    </>
  );
};

export default ApiTable;
